export default __webpack_public_path__ + "static/media/spain.1db5cf94.jpg";